import React from 'react';
import { CustomButton } from 'components';
import {Box, IconButton} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { AddAssetProps } from 'models';
import {Link} from "react-router-dom";
import {AppPathList} from "../../router";
import VerticalAlignTop from "@material-ui/icons/VerticalAlignTop";
import {useMixpanel} from "../../analytics";

interface TrailerListTempProps extends AddAssetProps {}

export const TrailerListTemp = ({ onAddAsset }: TrailerListTempProps) => {
	const { t } = useTranslation('buttons');
	const mixpanel = useMixpanel();

	return (
		<>
			<Box mt={2} textAlign="center">
				<Link
					to={AppPathList.addTrailer}
					className="link flexGrow"
					onClick={() => {
						mixpanel.track('Add trailer button clicked');
					}}>
					<CustomButton className="capitalizeText">
						{t('add_trailers')}
					</CustomButton>
				</Link>
			</Box>
			<Box mt={2} textAlign="center" paddingBottom={2}>
				<IconButton size="small" color="primary" className="text-small" onClick={onAddAsset}>
					<Box mr={1}><VerticalAlignTop  className="subtitle"/></Box>
					{t('upload_details')}
				</IconButton>
			</Box>
		</>
	);
};
